const organization_es = require('./organization.json')
export default organization_es